<div class="mb-25">
  <!-- Breadcrumb removed but spacing maintained -->
</div>

<div class="add-user-btn">
  <button mat-fab color="primary" matTooltip="Dodaj novog korisnika" (click)="goToToCreateUser()">
    <mat-icon>add</mat-icon>
  </button>
</div>

<div class="users-container">
  @for (user of filteredUsers; track user) {
    <div class="col-lg-4 col-md-6 user-card">
      <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
          <mat-card-title>
            <h5 class="mb-0">{{ user.userName }}</h5>
          </mat-card-title>
          <mat-card-subtitle>
            <p></p>
          </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <p>
            <strong>Ime:</strong> {{ user.firstName }}
          </p>
          <p>
            <strong>Prezime:</strong> {{ user.lastName }}
          </p>
          <p>
            <strong>Aktivan:</strong> {{ user.isActive }}
          </p>
        </mat-card-content>
        <mat-card-actions>
          <button mat-icon-button color="primary" matTooltip="Uredite korisnika" (click)="goToEditUser(user)">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button color="warn" matTooltip="Obrišite korisnika" (click)="confirmDelete(user)">
            <mat-icon>delete</mat-icon>
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
  }
</div>